import { entryContextQueryOptions } from "./hooks/context/entryContextQueryOptions";
import { webComponentQueryClient } from "./reactWrapper";

type PrefetchEntryContextParams = {
  backendHost?: string;
};

export function prefetchEntryContext({
  backendHost,
}: PrefetchEntryContextParams) {
  return webComponentQueryClient.prefetchQuery(
    entryContextQueryOptions(backendHost),
  );
}
